export const card = {
    visible: {
      y: 0,
      opacity: 1,
    },
    hidden: {
      y: 50,
      opacity: 0,
    },
  };
  
  export const bookCards = {
    visible: {
        transition: { staggerChildren: 0.075, delayChildren: 0.05 },
      },
  };
  
  export const bookOverlayContainer = {
    visible: {
      y: 0,
    },
    hidden: {
      y: 20,
    },
  };

  export const modal = {
    visible: {
      y: 0,
      opacity: 1,
    },
    hidden: {
      y: 25,
      opacity: 0,
    },
  };